/**
 * @file EmptyPageStart.tsx
 * @description Пустая страница в структуре (phase19.16 Р2; uiux-design-r2
 * §9): «На странице пока нет блоков — добавьте первый», [+ Добавить первый
 * блок] и три первых экрана из библиотеки — нажатие вставляет сразу.
 */

import { SECTION_PRESETS, type SiteColors } from "@chaiberi/shared";
import type { CSSProperties } from "react";

import { useSiteView } from "../../site-view/site-view-context";
import { useBuilder } from "../builder-context";
import { PresetCard } from "../section/PresetCard";
import { AddBlockMenu } from "./AddBlockMenu";

const roleVars = (colors: SiteColors | null): CSSProperties =>
  colors ? (Object.fromEntries(Object.entries(colors).map(([r, hex]) => [`--site-color-${r}`, hex])) as CSSProperties) : {};

export function EmptyPageStart() {
  const b = useBuilder();
  const view = useSiteView();
  const heroes = SECTION_PRESETS.filter((p) => p.group === "hero").slice(0, 3);
  return (
    <div className="flex flex-col gap-3 rounded-xl bg-surface-low p-3" style={roleVars(view.parts?.theme.theme.colors ?? null)}>
      <p className="type-body text-on-surface">На странице пока нет блоков — добавьте первый.</p>
      <AddBlockMenu label="Добавить первый блок" after={undefined} />
      <span className="type-caption text-on-surface-variant">Или начните с первого экрана:</span>
      <div role="radiogroup" aria-label="Первые экраны" className="flex flex-col gap-2">
        {heroes.map((preset) => (
          <PresetCard
            key={preset.key}
            preset={preset}
            selected={false}
            blockedReason={null}
            onSelect={() =>
              void b.blocks.addPreset(preset, undefined).then((id) => {
                if (!id) return;
                void b.select({ sel: { kind: "block", id }, panel: null });
                if (preset.backgroundPhoto) b.setBgPhotoRequest(id);
              })
            }
            onInsert={() => undefined}
          />
        ))}
      </div>
    </div>
  );
}
